const ApiTabs = {
    'body':'',
    'start':function(){
        let self = this;
        self.init();
        self.setTabs();
    },
    'setTabs': function(){
        let self = this;
        let tabs = self.body.find('.tabs');
        tabs.each(function(){
            let tabWrapper = $(this);
            let tabTriggers = tabWrapper.find('[tab-trigger]');
            let tabNames = tabWrapper.find('[tab-name]');
            // console.log(tabNames.length);

            tabTriggers.unbind('click');
            tabTriggers.each(function(){
                let tabTrigger = $(this);
                tabTrigger.on('click', function(){
                    let thisClick = $(this);
                    let tabTriggerValueString = thisClick.attr('tab-trigger');
                    let tabTriggerValues = tabTriggerValueString.split('|');

                    tabNames.addClass('hidden');
                    tabTriggers.removeClass('active');

                    $.each(tabTriggerValues, function(idx, value){
                        let tabTriggerValue = tabTriggerValues[idx];
                        let tabName = tabWrapper.find('[tab-name="'+tabTriggerValue+'"]');
                        let activeTabTriggers = tabWrapper.find('[tab-trigger="'+tabTriggerValueString+'"]');
                        let activeSubTabTriggers = tabWrapper.find('[tab-trigger="'+value+'"]');

                        // console.log(value);

                        if (tabName.length == 0){
                            let defaultTabTriggerValue = tabTriggerValue.replace('-1-', '-0-');
                            tabName = tabWrapper.find('[tab-name="'+defaultTabTriggerValue+'"]');
                            let defaultValue = value.replace('-1-', '-0-');
                            activeSubTabTriggers = tabWrapper.find('[tab-trigger="'+defaultValue+'"]');
                        }


                        tabName.removeClass('hidden');
                        activeTabTriggers.addClass('active');
                        activeSubTabTriggers.addClass('active');
                        //---
                        // console.log(tabName);
                    })
                    //-----
                    if (thisClick.attr('tab-scroll-top') !== undefined){
                        // console.log('scrollTop');
                        $('div.main').scrollTop(0);
                    }
                    //-----







                    // console.log('tab click');
                    //-----
                    ApiTables.start();
                });
            })
        });
    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiTabs.start();
});
